import '@/assets/icons/icon.css'
import javaScriptCallback from "@/assets/ts/jsNextInterface.js"
import { store } from '@/store/store'
import axios from 'axios'
import 'bootstrap'
import { BadgePlugin, ButtonPlugin, CardPlugin, CollapsePlugin, FormCheckboxPlugin, FormInputPlugin, FormPlugin, IconsPlugin, ImagePlugin, LayoutPlugin, ModalPlugin, OverlayPlugin, ProgressPlugin, VBTogglePlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bs-stepper/dist/css/bs-stepper.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import VConsole from "vconsole"
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import App from './App.vue'
import router from './router'
import LottieAnimation from 'lottie-web-vue'
Vue.prototype.$event = new Vue()
axios.interceptors.request.use(config => {
    store.state.isLoading = true;
    return config;
}, error => {
    store.state.isLoading = false;
    return Promise.reject(error);
});
axios.interceptors.response.use(config => {
    store.state.isLoading = false;
    return config;
}, error => {
    store.state.isLoading = false;
    return Promise.reject(error);
});
if (process.env.VUE_APP_VCONSOLE_FLAG == "true") {
    const vconsole = new VConsole();
    Vue.use(vconsole);
}
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$callback = javaScriptCallback
Vue.use(LayoutPlugin); // This imports all the layout components such as <b-container>, <b-row>, <b-col>
Vue.use(CardPlugin); // This imports <b-card> along with all the <b-card-*> sub-components as a plugin
Vue.use(ImagePlugin); // b-img, b-img-lazy
Vue.use(FormCheckboxPlugin); // b-form-checkbox
Vue.use(ButtonPlugin); // b-button
Vue.use(OverlayPlugin); // b-overlay
Vue.use(BadgePlugin); // b-badge
Vue.use(ProgressPlugin); // b-progress
Vue.use(ModalPlugin); // b-modal
Vue.use(IconsPlugin); // b-icon
Vue.use(FormInputPlugin); // b-form-input
Vue.use(FormPlugin);
Vue.use(VBTogglePlugin);
Vue.use(CollapsePlugin);
Vue.use(VueSweetalert2);
Vue.use(LottieAnimation);
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
Vue.prototype.$http.defaults.headers.common['Content-Type'] = 'application/json'